var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCachingWaves(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "caching_waves",
    width: 512,
    height: 512,
    viewBox: "0 0 135.47 135.47",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    id: "path2",
    d: "m67.736 0.49826c-37.104 0-67.234 30.13-67.234 67.234 1e-7 37.104 30.13 67.236 67.234 67.236 37.104 0 67.236-30.132 67.236-67.236 0-37.104-30.132-67.234-67.236-67.234zm0 4.7866c34.518 0 62.45 27.93 62.45 62.448 0 34.518-27.932 62.45-62.45 62.45-34.518 0-62.448-27.932-62.448-62.45 0-34.518 27.93-62.448 62.448-62.448z",
    color: "#000000",
    strokeLinejoin: "bevel",
    style: {
      InkscapeStroke: "none",
      paintOrder: "stroke fill markers"
    }
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCachingWaves);
export default __webpack_public_path__ + "static/media/caching_waves.e736be9bd7dec1685c3a446b6ce986a3.svg";
export { ForwardRef as ReactComponent };